import * as React from 'react';
import { connect } from 'react-redux';

import * as tokenService from '@nexxt/common/firebase/auth/userDetails';
import * as Action from '../../../actions/authentication.actions';
import * as tenantService from '../../../services/tenants.service';

import NotifyHOC from '../../../HOC/Notifications';
import Loader from '../../common/Loader/Loader';

import { ITenantBrief } from '../../../interface/tenant.interface';
import { ActiveUser } from '../../../interface/user.interface';
import { PROJECT_MANAGER } from '@nexxt/common/constants';
import { createTenantValidationSchema } from '../../common/validation/validationSchema';
import { alertMessage } from '../../../constants/alertMessage';
import config from '../../../config';
import Users from '../manageUser';
import ValidationService from '@nexxt/common/services/ValidationService';
import HelperTooltip from '../../common/HelperTooltip';

interface IAccountReviewProps {
    toastNotification: any;
    setTenant: (tenant: ITenantBrief) => void;
    user: ActiveUser;
    tenant: any;
}

interface IFormErrors {
    tenantName: string;
}
interface IAccountReviewState {
    accountUrl: string;
    tenantName: string;
    isRequesting: boolean;
    tenantId: number;
    editMode: boolean;
    formErrors: IFormErrors;
}
class AccountReview extends React.Component<
    IAccountReviewProps,
    IAccountReviewState
> {
    accountNameInput;
    validationService;
    constructor(props) {
        super(props);
        this.validationService = new ValidationService();
        this.state = {
            accountUrl: '',
            tenantName: '',
            isRequesting: false,
            tenantId: null,
            editMode: false,
            formErrors: {
                tenantName: ''
            }
        };
    }
    prevName = '';
    setEditMode(mode) {
        if (mode) {
            this.prevName = this.state.tenantName;
        } else {
            this.setState({
                tenantName: this.prevName,
                formErrors: {
                    tenantName: ''
                }
            });
        }
        this.setState({ editMode: mode }, () => {
            this.accountNameInput.focus();
        });
    }

    componentDidMount() {
        const accessType = tokenService.getAccessType();
        if (accessType === PROJECT_MANAGER) {
            this.props.toastNotification.info(
                'Project manager is not allowed to change account name!'
            );
        }
        const tenantId = tokenService.getTenantId();
        const { accountUrl } = this.props.user;
        const tenantName = tokenService.getTenantName();

        this.setState({
            accountUrl,
            tenantName,
            tenantId
        });
    }

    handleInput = (e) => {
        this.setState(
            {
                tenantName: e.target.value
                // formErrors: {
                //     tenantName: "",
                // },
            },
            () => {
                this.validateForm();
            }
        );
    };

    editTenantName = async (e) => {
        if (await this.validateForm()) {
            this.setState({
                isRequesting: true
            });
            const tenant = {
                id: this.state.tenantId,
                tenantName: this.state.tenantName,
                url: this.props.tenant.tenantURL
            };
            try {
                await tenantService.updateName(this.state.tenantId, {
                    tenantName: this.state.tenantName
                });

                await this.props.setTenant(tenant);
                this.setState({
                    isRequesting: false
                });

                this.props.toastNotification.success(
                    alertMessage.EDIT_TENANT_NAME
                );
                window.location.reload();
            } catch (error) {
                this.setState({
                    isRequesting: false
                });
                this.props.toastNotification.error(
                    alertMessage.UNABLE_TO_EDIT_TENANT_NAME
                );
            }
        }
        e.preventDefault();
    };

    validateForm = async () => {
        const formErrors: any = {};
        let isFormValid = true;
        console.log('this.state.tenantName', this.state.tenantName);

        await createTenantValidationSchema()
            .fields.tenantName.isValid(this.state.tenantName)
            .then((valid) => {
                if (!valid) {
                    isFormValid = false;
                    if (this.validationService.isEmpty(this.state.tenantName)) {
                        formErrors.tenantName = 'Account name is required';
                    } else if (this.state.tenantName.length < 2) {
                        formErrors.tenantName =
                            'Your account name must contain atleast 2 characters.';
                    } else {
                        formErrors.tenantName =
                            "You can not start with _ or -. You can't use numbers or special symbols.";
                    }
                }
            });

        this.setState({
            formErrors
        });

        return isFormValid;
    };

    renderButtons() {
        const accessType = tokenService.getAccessType();

        if (!this.state.editMode) {
            return (
                <button
                    type="button"
                    onClick={() => this.setEditMode(true)}
                    className="btn btn--sm btn--blue"
                    disabled={accessType === PROJECT_MANAGER}
                >
                    Edit
                </button>
            );
        } else {
            return (
                <React.Fragment>
                    <button
                        type="button"
                        onClick={this.editTenantName}
                        className="btn btn--sm btn--blue"
                        disabled={accessType === PROJECT_MANAGER}
                    >
                        Save
                    </button>
                    <button
                        type="button"
                        className="btn btn--sm btn--lt-gray m-l-10"
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.setEditMode(false)}
                    >
                        Cancel
                    </button>
                </React.Fragment>
            );
        }

        /*if (!this.state.editMode) {
            return (
                <button
                    type="button"
                    onClick={() => this.setEditMode(true)}
                    className="btn btn--sm btn--teal-blue"
                    disabled={
                        accessType === PROJECT_MANAGER
                    }
                >Edit</button>
            )
        } else {
            return (
                <button type="button"
                onClick={this.editTenantName}
                className="btn btn--sm btn--teal-blue"
                disabled={
                    accessType === PROJECT_MANAGER
                }
            >Save</button>
            <span style={{ cursor: 'pointer' }} onClick={() => this.setEditMode(false)}>Cancel</span>
             )
        }*/
    }

    render() {
        if (this.state.isRequesting) {
            return <Loader />;
        }

        return (
            <>
                <div className="card-container">
                    {this.props.user &&
                    Object.keys(this.props.user).length > 0 ? (
                        <React.Fragment>
                            <div className="card-container__title">
                                Account Overview
                            </div>
                            <div className="card-wrapper bg-white">
                                <div className="card-wrapper--body card-wrapper--account">
                                    <form className="form">
                                        <div
                                            className={
                                                this.state.formErrors.tenantName
                                                    ? 'form-group error'
                                                    : 'form-group'
                                            }
                                        >
                                            <HelperTooltip
                                                pathname="Account Name"
                                                placement="bottom"
                                                textSize="small"
                                                icon={true}
                                            >
                                                <label className="form-group__label form-group__label--block">
                                                    Account Name:
                                                </label>
                                            </HelperTooltip>
                                            <input
                                                ref={(input) => {
                                                    this.accountNameInput =
                                                        input;
                                                }}
                                                name="tenantName"
                                                type="text"
                                                className="form-group__control disabled"
                                                value={this.state.tenantName}
                                                onChange={this.handleInput}
                                                required={true}
                                                disabled={!this.state.editMode}
                                            />
                                            {(this.state.formErrors &&
                                                this.state.formErrors
                                                    .tenantName && (
                                                    <span className="form-group__error-msg">
                                                        {
                                                            this.state
                                                                .formErrors
                                                                .tenantName
                                                        }
                                                    </span>
                                                )) || (
                                                <span
                                                    className="form-group__error-msg"
                                                    style={{
                                                        display: 'block',
                                                        opacity: 0
                                                    }}
                                                >
                                                    &nbps;
                                                </span>
                                            )}
                                        </div>

                                        <div className="form-group">
                                            {this.renderButtons()}
                                        </div>

                                        <div className="form-group">
                                            <HelperTooltip
                                                pathname="Account Custom URL"
                                                placement="bottom"
                                                textSize="small"
                                                icon={true}
                                            >
                                                <label className="form-group__label form-group__label--block">
                                                    Account Custom URL:
                                                </label>
                                            </HelperTooltip>
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-group__control disabled"
                                                    disabled={true}
                                                    value={
                                                        this.state.accountUrl
                                                    }
                                                />
                                                <div className="input-group-append">
                                                    <span
                                                        className="input-group-text"
                                                        id="basic-addon2"
                                                    >
                                                        {config.host.domain}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </React.Fragment>
                    ) : (
                        <Loader />
                    )}
                </div>
                <Users />
            </>
        );
    }
}

const mapStateToProps = (store) => {
    const {
        authReducer: { user, tenant }
    } = store;
    return {
        user,
        tenant
    };
};

const mapDispatchToProps = (dispatch) => ({
    setTenant: (tenant) => {
        dispatch(Action.setTenant(tenant));
    }
});

export default NotifyHOC(
    connect(mapStateToProps, mapDispatchToProps)(AccountReview)
);
